import * as React from 'react';
import PropTypes from 'prop-types';

import SVGMap from './SVGMap';
import ThreeMap from './ThreeMap';
import POIDetail from './POIDetail';

import Waypoint from '../classes/Waypoint';
import POI from '../classes/POI';

import { RENDERER_THREE, RENDERER_SVG } from '../constants/map';

// transform: rotate3d(3, -2, 3, 97deg);

/**
 * A class which controls map display based on props
 * Currently passes props from Map container (TODO: Replace with React Context)
 *
 * @class Map
 * @returns {React.Component}
 */
class Map extends React.Component {
    render () {
        const { selectedMap,
                renderer,
                origin,
                destination,
                setOrigin,
                setDestination,
                setSelectedPOI,
                selectedPOI,
                setError,
                locatables,
                mapOverride,
                hidden,
                retro,
            } = this.props;

        // if (!selectedMap) {
        //     return (
        //         <h1 className="has-text-centered title">
        //         </h1>
        //     );
        // }

        if (!renderer) {
            throw new Error('Map:Map : No renderer is selected.');
        }

        let map = null;
        if (renderer === RENDERER_SVG) {
        map = <SVGMap
                    mapName={mapOverride}   // was (before hack-a-thon): mapName={selectedMap}
                    setOrigin={setOrigin}
                    setDestination={setDestination}
                    setSelectedPOI={setSelectedPOI}
                    origin={origin}
                    destination={destination}
                    setError={setError}
                    locatables={locatables}
                />;
        }
        else if (renderer === RENDERER_THREE) {
            map = <ThreeMap
                    mapName={selectedMap}
                    setOrigin={setOrigin}
                    setDestination={setDestination}
                    setSelectedPOI={setSelectedPOI}
                    origin={origin}
                    destination={destination}
                    setError={setError}
                />;
        }

        // Determine if POI detail should render
        let detail = null;
        if (selectedPOI) {
            detail = <POIDetail
                        selectedPOI={selectedPOI}
                        setSelectedPOI={setSelectedPOI}
                        setDestination={setDestination}
                    />;
        }

//SIDE STYLE MULTI LEVEL TRANSFORM SET:
        // const topSet = ((4 - mapOverride.level) * 14 - 56) + 'vh';
        // const topRetro = "-5vh";
        // let zed = 0;
        // let angler = "scaleX(0.75) scaleY(0.75) rotate(90deg) rotate3d(0, 1, 0, " +
        //               ((mapOverride.level === 2) ? (hidden ? "45deg" : " 70deg") : (hidden ? "80deg" : " 70deg"))
        //               + ")";
        // if (selectedMap) {
        //     angler = "scaleX(0.75) scaleY(0.75) rotate(90deg) rotate3d(0, 1, 0, " +
        //               ((mapOverride.level === selectedMap.level) ? (hidden ? "45deg" : " 70deg") : (hidden ? "80deg" : " 70deg"))
        //               + ")";
        //     zed = (mapOverride.level === selectedMap.level) ? 1 : 0;
        // }

// TILT ONE BACK WITH ME DOG SET: ;)
        // const topSet = ((4 - mapOverride.level) * 34 - 66) + 'vh';
        // const topRetro = "-5vh";
        // let zed = 0;
        // let angler = "scaleX(1) scaleY(0.55) rotate(60deg) rotate3d(1, 0, 0, " +
        //               ((mapOverride.level === 2) ? (hidden ? "45deg" : " 70deg") : (hidden ? "80deg" : " 70deg"))
        //               + ")";
        // if (selectedMap) {
        //     angler = "scaleX(1) scaleY(0.55) rotate(60deg) rotate3d(1, 0, 0, " +
        //               ((mapOverride.level === selectedMap.level) ? (hidden ? "45deg" : " 70deg") : (hidden ? "80deg" : " 70deg"))
        //               + ")";
        //     zed = (mapOverride.level === selectedMap.level) ? 1 : 0;
        // }

// FINE TUNE TILT SET: ;)
        const topSet = ((4 - mapOverride.level) * 34 - 66) + 'vh';
        const topRetro = "-5vh";
        let zed = 0;
        let angler = "scaleX(1) scaleY(0.55) rotate3d(6,-2,5,70deg) ";
        if (selectedMap) {
            angler = "scaleX(1) scaleY("
            + ((mapOverride.level === selectedMap.level) ? (hidden ? "1" : "0.55") : (hidden ? "0.55" : "0.55")) +
            ") rotate3d(6,-2,5,70deg) ";
            zed = (mapOverride.level === selectedMap.level) ? 1 : 0;
        }

//rotate3d(6,-2,5,70deg)

        const noAngler = "scaleX(1) scaleY(1) rotate(0deg) rotate3d(0, 0, 0, 0deg)";
        //const hider = (mapOverride.level === 2) ? 1 : ((hidden || retro) ? 0.2 : 1);
        const hider = (selectedMap)
            ? ((mapOverride.level === selectedMap.level) ? 1 : ((hidden || retro) ? 0 : 1))
            : (mapOverride.level === 2) ? 1 : ((hidden || retro) ? 0 : 1);

        // if selectedMap and retro then if selectedMap.id === mapOverride.id then show else hide

        return (
            <section key={mapOverride.id} style={{transition: "500ms", height: "100vh", width: "100vw", position: "absolute", top: retro ? topRetro : topSet,
                            transform: retro ? noAngler : angler, opacity: hider, zIndex: zed}}>
                { detail }
                { map }
            </section>
        );
    }
}

Map.propTypes = {
    selectedMap: PropTypes.object,
    renderer: PropTypes.string,
    origin: PropTypes.instanceOf(Waypoint),
    destination: PropTypes.instanceOf(Waypoint),
    setDestination: PropTypes.func,
    setOrigin: PropTypes.func,
    setSelectedPOI: PropTypes.func,
    selectedPOI: PropTypes.instanceOf(POI),
    setError: PropTypes.func.isRequired,
    locatables: PropTypes.object,
}

export default Map;



// WEBPACK FOOTER //
// ./src/components/Map.js